import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    uid: "",
    chatActive: false,
    postActive: false,
    activeGroup: {
      groupID: "",
      details: null
    }
  },
  mutations: {
    // Logged in user's identifier
    setUID(state, uid) {
      state.uid = uid;
    },
    // This is to store the currently active group between projects feature pages
    // Prevents having to reload from the firebase firestore on switches
    // the details is just the surface level group data, not the projects subcollections
    setActiveGroup(state, { details, groupID }) {
      state.activeGroup.details = details;
      state.activeGroup.groupID = groupID;
    },
    toggleChatActive(state) {
      state.chatActive = !state.chatActive;
    },
    togglePostActive(state) {
      state.postActive = !state.postActive;
    }
  },
  actions: {},
  getters: {
    uid: state => state.uid,
    activeGroup: state => state.activeGroup,
    chatActive: state => state.chatActive,
    postActive: state => state.postActive
  }
});



// WEBPACK FOOTER //
// ./src/store.js